var map = {
	"./CentOs-show.png": 9055,
	"./CentOs.png": 9269,
	"./Linux-show.png": 7149,
	"./Linux.png": 6683,
	"./Ubuntu-show.png": 8064,
	"./Ubuntu.png": 3188,
	"./Windows-show.png": 3402,
	"./Windows.png": 9230
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9054;